import { cn } from '@1trading/react';
import type { LucideIcon } from 'lucide-react';

export type StatusChipVariant = 'success' | 'warning' | 'destructive' | 'info' | 'muted';

const VARIANT_CLASSES: Record<StatusChipVariant, string> = {
  success: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-500',
  warning: 'border-amber-500/40 bg-amber-500/10 text-amber-500',
  destructive: 'border-red-500/40 bg-red-500/10 text-red-500',
  info: 'border-blue-500/40 bg-blue-500/10 text-blue-400',
  muted: 'border-border bg-muted text-muted-foreground',
};

export type StatusChipSize = 'default' | 'sm';

/** Exported so chip-shaped buttons and links can match a chip's size */
export const STATUS_CHIP_SIZE_CLASSES: Record<StatusChipSize, string> = {
  default: 'px-3 py-1 text-sm',
  sm: 'px-2.5 py-0.5 text-xs',
};

interface StatusChipProps {
  variant?: StatusChipVariant;
  size?: StatusChipSize;
  icon?: LucideIcon;
  className?: string;
  children: React.ReactNode;
}

export const StatusChip = ({ variant = 'muted', size = 'default', icon: Icon, className, children }: StatusChipProps) => (
  <span className={cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border font-medium', STATUS_CHIP_SIZE_CLASSES[size], VARIANT_CLASSES[variant], className)}>
    {Icon ? <Icon className="size-4" /> : null}
    {children}
  </span>
);
StatusChip.displayName = 'StatusChip';
